// <bogo-products> — BOGO campaign grid.
// Tabs filter the server-rendered grid client-side (no reload), and clicking a product opens the
// quick-view modal (color + size picker) instead of navigating to the PDP.
if (!customElements.get('bogo-products')) {
  customElements.define(
    'bogo-products',
    class BogoProducts extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('.bogo-products__tab')];
        this.items = [...this.querySelectorAll('.bogo-products__item')];

        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
        this.addEventListener('click', (event) => this.openPreview(event));
      }

      select(activeTab) {
        const handle = activeTab.dataset.collection;

        this.tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab === activeTab)));
        this.items.forEach((item) => {
          item.hidden = Boolean(handle) && !item.dataset.collections.split(' ').includes(handle);
        });
      }

      openPreview(event) {
        // Let modified clicks (new tab/window) through to the PDP.
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const link = event.target.closest('.product-card-media-link, .card__heading a');
        if (!link || event.target.closest('.quick-add-button, .quick-add-button-alt')) return;

        // Sold-out cards have no enabled quick-add button — keep the PDP link.
        const quickAdd = link.closest('.bogo-products__item')?.querySelector('.quick-add-button:not([disabled])');
        if (!quickAdd) return;

        event.preventDefault();
        quickAdd.click();
      }
    }
  );
}
